import { render, staticRenderFns } from "./LighteningDeals.vue?vue&type=template&id=05a0c8a4"
import script from "./LighteningDeals.vue?vue&type=script&lang=js"
export * from "./LighteningDeals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports